var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _vm.hotel
                ? _c("FormHotel", {
                    attrs: {
                      data: _vm.hotel,
                      loading: _vm.isLoading,
                      disabled: _vm.isMutationLoading,
                      isNew: !_vm.id,
                      language: _vm.language,
                      cities: _vm.cities,
                      types: _vm.types,
                      facilities: _vm.facilities,
                      amenities: _vm.amenities,
                      tabs: _vm.allowedTabs,
                      currentTab: _vm.tab,
                      "reservations-count": _vm.reservationsCount,
                    },
                    on: {
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-hotels" })
                      },
                      "delete-hotel": _vm.deleteHotel,
                      "language-update": function ($event) {
                        _vm.language = $event
                      },
                      "remove-room": _vm.deleteRoom,
                      "remove-room-type": _vm.deleteRoomType,
                      submit: _vm.hotelSubmitHandle,
                      onwards: _vm.onwardsHandler,
                      "change:descriptionForMobile": function ($event) {
                        return _vm.changeDescForMobHandler($event)
                      },
                      "change:shortDescriptionForMobile": function ($event) {
                        return _vm.changeShortDescForMobHandler($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmHotelRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }